import { Route, Routes } from "react-router-dom";
import { ToastProvider, useLang } from "@b00k/ui";
import { DICTS, I18nContext } from "./i18n/index.js";
import { SiteHeader } from "./components/SiteHeader.js";
import { LandingPage } from "./pages/LandingPage.js";
import { SignupWizardPage } from "./pages/SignupWizardPage.js";

export function App() {
  const [lang, setLang] = useLang("pl");
  const t = DICTS[lang];
  return (
    <I18nContext.Provider value={t}>
      <ToastProvider>
        <SiteHeader lang={lang} onLang={setLang} />
        <Routes>
          <Route path="/" element={<LandingPage lang={lang} />} />
          <Route path="/rejestracja" element={<SignupWizardPage lang={lang} />} />
          <Route path="*" element={<LandingPage lang={lang} />} />
        </Routes>
      </ToastProvider>
    </I18nContext.Provider>
  );
}
